// extracted by mini-css-extract-plugin
module.exports = {"delete-icon":"_3k5-MApXt4fkiMvgIM0t3R"};